import './editor-toolbar-divider.scss';

export function EditorToolBarDivider() {
  return <div className="editor-toolbar-divider" />;
}
